import { HttpHeaders } from '@angular/common/http';
import { GalavailRestService } from 'clientwsGalavail';
import * as i0 from "@angular/core";
import * as i1 from "clientwsGalavail";
var OnholdService = /** @class */ (function () {
    function OnholdService(galavailRestService) {
        this.galavailRestService = galavailRestService;
    }
    OnholdService.prototype.onHold = function (requestOnhold) {
        var httpHeaders = new HttpHeaders({});
        var restServiceItemName = 'requestG_blockCabin';
        return this.galavailRestService.request(null, restServiceItemName, { headers: httpHeaders }, requestOnhold, requestOnhold.email);
    };
    OnholdService.ngInjectableDef = i0.defineInjectable({ factory: function OnholdService_Factory() { return new OnholdService(i0.inject(i1.GalavailRestService)); }, token: OnholdService, providedIn: "root" });
    return OnholdService;
}());
export { OnholdService };
